module.exports = __webpack_public_path__ + "img/plus-black.00b956b6.svg";